import React from 'react';

class Icon extends React.Component {
    constructor(props) {
        super(props);
    }

    fetchType() {
        let svg = false;
        switch (this.props.type) {
            case 'star_on':
                svg =
                <svg width="100" height="100" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <polygon id="Star" fill="#7DBCA4" points="50 82.9179607 19.0983006 100 25 63.8196601 1.73194792e-14 38.1966011 34.5491503 32.9179607 50 0 65.4508497 32.9179607 100 38.1966011 75 63.8196601 80.9016994 100"></polygon>
                    </g>
                </svg>;
                break;
            case 'mail_circle':
                svg =
                <svg width="36" height="36" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle id="icon" r="14" cx="18" cy="18" fill="#fff" />
                    <path d="M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 
                        0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M26.1818182,14.7272727 L18.1994318,18.2916826 
                        C18.1360227,18.3208018 18.0675,18.3348222 18,18.3348222 C17.9325,18.3348222 17.8639773,18.3208018 
                        17.8005682,18.2916826 L9.81818182,14.7272727 L9.81818182,22.6487826 C9.81818182,23.2441092 
                        10.2763636,23.7272727 10.8409091,23.7272727 L25.1590909,23.7272727 C25.7236364,23.7272727 
                        26.1818182,23.2441092 26.1818182,22.6487826 L26.1818182,14.7272727 Z M25.1590909,12.2727273 
                        L10.8409091,12.2727273 C10.2763636,12.2727273 9.81818182,12.7163974 9.81818182,13.2630623 
                        L9.81818182,13.826563 L18,17.1818182 L26.1818182,13.8255727 L26.1818182,13.2630623 
                        C26.1818182,12.7163974 25.7236364,12.2727273 25.1590909,12.2727273 Z" />
                </svg>;
                break;
            case 'pinterest_circle':
                svg =
                <svg data-pin-nopin="true" width="36" height="36" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle id="icon" r="14" cx="18" cy="18" fill="#fff" />
                    <path d="M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 
                        0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M18.4756591,9.63636364 C13.7734325,9.63636364 
                        11.2727273,12.574224 11.2727273,15.7776419 C11.2727273,17.2633001 12.1241681,19.1159295 
                        13.4871168,19.7035016 C13.6940791,19.7944603 13.8066751,19.7557767 13.8527859,19.5686318 
                        C13.893535,19.4264436 14.0726164,18.7416398 14.1594762,18.4185797 C14.1862848,18.315075 
                        14.1723443,18.2251619 14.0865568,18.1279302 C13.6340278,17.6177253 13.2747927,16.6882741 
                        13.2747927,15.8163255 C13.2747927,13.5820879 15.0967045,11.4126714 18.1968498,11.4126714 
                        C20.8777087,11.4126714 22.7532376,13.1105665 22.7532376,15.5392675 C22.7532376,18.28371 
                        21.2637524,20.1823415 19.3281722,20.1823415 C18.256901,20.1823415 17.4590774,19.362668 
                        17.7121505,18.3485311 C18.0177684,17.1409764 18.6172084,15.842463 18.6172084,14.9715599 
                        C18.6172084,14.19057 18.1646794,13.5444498 17.2403193,13.5444498 C16.1497459,13.5444498 
                        15.2650624,14.5972702 15.2650624,16.0107888 C15.2650624,16.908875 15.5910549,17.5152661 
                        15.5910549,17.5152661 C15.5910549,17.5152661 14.5122772,21.7641859 14.311749,22.5577218 
                        C13.9728884,23.9011918 14.3578597,26.0768813 14.3911024,26.2640261 C14.4114769,26.3675308 
                        14.5305071,26.3999414 14.5969924,26.3152557 C14.7031544,26.1793405 16.0071242,24.3653946 
                        16.3727933,23.0543352 C16.5057639,22.5765409 17.0515868,20.6392258 17.0515868,20.6392258 
                        C17.4108219,21.2717545 18.4477782,21.8018239 19.552292,21.8018239 C22.8379528,21.8018239 
                        25.2121214,18.9862873 25.2121214,15.4922199 C25.2003257,12.1424317 22.2599596,9.63636364 
                        18.4756591,9.63636364 Z" />
                </svg>;
                break;
            case 'x_circle':
                svg =
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 963 963">
                    <g transform="translate(-353.3,-129)">
                        <circle cx="834.28" cy="610.6" r="481.33" stroke="#fff" strokeMiterlimit="10" />
                        <path fill="#fff" d="M485.39,356.79l230.07,307.62L483.94,914.52h52.11l202.7-218.98l163.77,218.98h177.32L836.82,589.6l215.5-232.81h-52.11L813.54,558.46L662.71,356.79H485.39z M562.02,395.17h81.46l359.72,480.97h-81.46L562.02,395.17z" transform="translate(52.39 -25.059)" />
                    </g>
                </svg>
                break;
            case 'bloglovin_square':
                svg =
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                            <g fill="#000">
                                <path d="M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0zm-1.291 11H9v14.87h7.95c2.812 0 4.262-1.785 4.262-4.035-.006-1.849-1.234-3.387-2.818-3.633 1.38-.29 2.525-1.558 2.525-3.413 0-1.985-1.424-3.789-4.21-3.789zm-.554 8.695c1.209 0 1.864.757 1.864 1.694.006 1.067-.7 1.694-1.864 1.694h-4.038v-3.388h4.038zm8.892-8.67c-.941 0-1.736.803-1.736 1.76 0 .956.661 1.603 1.495 1.603.178 0 .35-.02.42-.065-.179.802-.986 1.74-1.692 2.12l1.208 1.003c1.355-.977 2.258-2.47 2.258-4.144 0-1.449-.922-2.276-1.953-2.276zm-9.025 2.761c1.056 0 1.71.647 1.71 1.558 0 .957-.66 1.559-1.71 1.559h-3.905v-3.117h3.905z"></path>
                            </g>
                        </g>
                    </svg>;
                break;
            case 'facebook_circle':
                svg =
                <svg width="36" height="36" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle id="icon" r="14" cx="18" cy="18" fill="#fff" />
                    <path d="M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 
                        0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M20.2333784,8.63636364 C17.9002205,8.63636364 
                        16.3019446,10.1040341 16.3019446,12.8015342 L16.3019446,15.284091 L13.7272727,15.284091 
                        L13.7272727,18.4351138 L16.3019446,18.4351138 L16.3019446,26.3636366 L19.4586134,26.3636366 
                        L19.4586134,18.4358524 L21.9291462,18.4358524 L22.3213294,15.2848296 L19.4578748,15.2848296 
                        L19.4578748,13.1139773 C19.4586134,12.2032387 19.7038202,11.5798296 20.9726918,11.5798296 
                        L22.5909092,11.5798296 L22.5909092,8.76119318 C22.3117279,8.72278409 21.3515807,8.63636364 
                        20.2333784,8.63636364 Z" />
                </svg>;
                break;
            case 'comment_circle':
                svg =
                <svg width="36" height="36" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle id="icon" r="14" cx="18" cy="18" fill="#fff" />
                    <path d="M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M26,10 L10,10 C8.8954305,10 8,10.8954305 8,12 L8,12 L8,23.7894737 C8,24.8940432 8.8954305,25.7894737 10,25.7894737 L10,25.7894737 L16.4210526,25.7894737 L18,28.9473684 L19.5789474,25.7894737 L26,25.7894737 C27.1045695,25.7894737 28,24.8940432 28,23.7894737 L28,23.7894737 L28,12 C28,10.8954305 27.1045695,10 26,10 L26,10 Z" />
                </svg>;
                break;
            case 'share_circle':
                svg =
                <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle id="icon" r="15" cx="24" cy="24" fill="#000000" />
                    <g id="circle" fill="#FFFFFF">
                        <path d="M24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M30,14 C28.34,14 27,15.34 27,17 C27,17.24 27.04,17.47 27.09,17.7 L20.04,21.81 C19.5,21.31 18.79,21 18,21 C16.34,21 15,22.34 15,24 C15,25.66 16.34,27 18,27 C18.79,27 19.5,26.69 20.04,26.19 L27.16,30.35 C27.11,30.56 27.08,30.78 27.08,31 C27.08,32.61 28.39,33.92 30,33.92 C31.61,33.92 32.92,32.61 32.92,31 C32.92,29.39 31.61,28.08 30,28.08 C29.24,28.08 28.56,28.38 28.04,28.85 L20.91,24.7 C20.96,24.47 21,24.24 21,24 C21,23.76 20.96,23.53 20.91,23.3 L27.96,19.19 C28.5,19.69 29.21,20 30,20 C31.66,20 33,18.66 33,17 C33,15.34 31.66,14 30,14 Z" />
                    </g>
                </svg>;
                break;
            case 'close_circle':
                svg =
                <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle id="icon" r="15" cx="24" cy="24" fill="#000000" />
                    <g id="circle" fill="#FFFFFF">
                        <path d="M24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M30.363961,16.2218254 L23.9998254,22.5858254 L17.636039,16.2218254 L16.2218254,17.636039 L22.5858254,23.9998254 L16.2218254,30.363961 L17.636039,31.7781746 L23.9998254,25.4138254 L30.363961,31.7781746 L31.7781746,30.363961 L25.4138254,23.9998254 L31.7781746,17.636039 L30.363961,16.2218254 Z" />
                    </g>
                </svg>;
                break;
            default:
                break;
        }

        return svg;
    }

    render() {
        return this.fetchType();
    }
}

export default Icon;